import { IQuantitySectionProp } from './QuantitySection.types';
import { useQuantitySectionStyles } from './QuantitySection.styles';
import { useState } from 'react';
import { usePageTitleStyles } from 'components/core/Page/PageTitle/PageTitle.styles';

const QuantitySection = (props: IQuantitySectionProp) => {
    const { cartView, readonly, startingQuantity, maxQuantity, onChange } = props;
    const styles = useQuantitySectionStyles();
    const headerStyles = usePageTitleStyles();

    const [count, setCount] = useState<number>(startingQuantity);

    const handleIncrement = () => {
        if (!maxQuantity || count < maxQuantity) {
            const newCount = count + 1;
            setCount(newCount);
            onChange(newCount);
        }
    };

    const handleDecrement = () => {
        if (count > 1) {
            const newCount = count - 1;
            setCount(newCount);
            onChange(newCount);
        }
    };

    return (
        <div className={styles.root}>
            {cartView ? (
                <div className={styles.cartHeader}>Qty{readonly && `: ${count}`}</div>
            ) : (
                <div className={headerStyles.root}>Quantity{readonly && `: ${count}`}</div>
            )}
            {!readonly && (
                <div className={styles.row}>
                    <button className={styles.button} onClick={handleDecrement}>
                        -
                    </button>
                    {cartView ? (
                        <span className={styles.cartCount}>{count}</span>
                    ) : (
                        <span className={styles.count}>{count}</span>
                    )}
                    <button className={styles.button} onClick={handleIncrement}>
                        +
                    </button>
                </div>
            )}
        </div>
    );
};

export default QuantitySection;
